interface IntroModalProps {
  onClose: () => void;
}

const IntroModal: React.FC<IntroModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md text-center">
        <p className="text-green-700 mb-6">
          Your registration is almost complete! Toothsketch officials will shortly complete profile verification, after which you can start using our services.
        </p>
        <button
          onClick={onClose}
          className="px-6 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default IntroModal;
